<template>
  <div class="public_bg">
    <div class="nurse_top">
      <div style="height:54px;line-height:54px;">
        <img style="vertical-align:middle;" src="@/assets/beadhouse/juxing.png" />
        <span>{{ LifeCareManagement.LifeCareManagement }}</span>
      </div>
    </div>
    <div class="row_link clearfix">
      <div class="item" v-for="(item, index) in infoList" :key="index" @click="handleClick(item.uid)">
        <a>
          <img :src="item.img" />
          <h5 style="font-size:16px;">{{ item.title }}</h5>
          <span>{{ item.text }}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "LifeCareManagement",
  data() {
    return {
      LifeCareManagement: {
        LifeCareManagement: "护理记录管理",
        title_1: "护工管理",
        title_2: "护工排班方案",
        title_3: "本周排班计划",
        title_4: "排班计划审批",
        title_5: "用药记录",
        title_6: "用药记录管理",
        title_7: "班长日志",
        title_8: "班长日志管理",
        title_9: "护工日志",
        title_10: "护工日志管理",
        title_11: "护工交班日志",
        title_12: "交班日志查看",
        title_13: "调房调级",
        title_14: "调房调级审批",
        title_15: "老人生日",
        title_16: "老人请假",
        title_17: "每周菜谱",
        title_18: "食物管理",
        title_19: "出院申请",
        title_20: "出院申请审批",
        text_1: "管理员对护工进行分组管理",
        text_2: "对班长的排班计划进行划分",
        text_3: "班长对本周的排班计划进行管理",
        text_4: "对排班计划进行管理审阅",
        text_5: "对护工每天的用药记录进行管理",
        text_6: "对护工记录的用药情况进行管理审阅",
        text_7: "班长对每天的异常情况进行记录",
        text_8: "对每天班长提交的日志进管理审阅",
        text_9: "护工对每天的日常护理进行记录",
        text_10: "对每天护工提交的日常护理进管理审阅",
        text_11: "护工每天下班前对每天的异常情况进行记录",
        text_12: "对每天的交班日志进行审批查阅",
        text_13: "对老人调整护理等级床位进行管理",
        text_14: "对老人调整护理等级床位进行管理",
        text_15: "班长对每天的异常情况进行记录",
        text_16: "对老人外出请假进行管理",
        text_17: "对每周的菜谱进行管理",
        text_18: "对菜谱食物进行设计管理",
        text_19: "老人申请出院的流程管理",
        text_20: "老人申请出院的流程管理"
      },//引入 lang 里面的字符串资源
      infoList: [] //数据源
    };
  },
  methods: {
    //点击每个
    handleClick(uid) {
      console.log(uid);
      switch (uid) {
        case 1:
          bus.$emit("homePage", {
            type: "jump",
            path: "/NursingManagement",
            title: this.LifeCareManagement.title_1
          });
          break;
        case 2:
          bus.$emit("homePage", {
            type: "jump",
            path: "/NursingArrangePlan",
            title: this.LifeCareManagement.title_2
          });
          break;
        case 3:
          bus.$emit("homePage", {
            type: "jump",
            path: "/ThisWeekArrangePlan",
            title: this.LifeCareManagement.title_3
          });
          break;
        case 4:
          bus.$emit("homePage", {
            type: "jump",
            path: "/SchedulingPlanApproval",
            title: this.LifeCareManagement.title_4
          });
          break;
        case 5:
          bus.$emit("homePage", {
            type: "jump",
            path: "/PharmacyRecord",
            title: this.LifeCareManagement.title_5
          });
          break;
        case 6:
          bus.$emit("homePage", {
            type: "jump",
            path: "/PharmacyRecordManagement",
            title: this.LifeCareManagement.title_6
          });
          break;
        case 7:
          bus.$emit("homePage", {
            type: "jump",
            path: "/MonitorLog",
            title: this.LifeCareManagement.title_7
          });
          break;
        case 8:
          bus.$emit("homePage", {
            type: "jump",
            path: "/MonitorLogManagement",
            title: this.LifeCareManagement.title_8
          });
          break;
        case 9:
          bus.$emit("homePage", {
            type: "jump",
            path: "/NursingLog",
            title: this.LifeCareManagement.title_9
          });
          break;
        case 10:
          bus.$emit("homePage", {
            type: "jump",
            path: "/NursingLogManagement",
            title: this.LifeCareManagement.title_10
          });
          break;
        case 25:
          bus.$emit("homePage", {
            type: "jump",
            path: "/NursingLogManagementMonth",
            title: this.LifeCareManagement.title_10
          });
          break;
        case 11:
          bus.$emit("homePage", {
            type: "jump",
            path: "/NursingHandoverLog",
            title: this.LifeCareManagement.title_11
          });
          break;
        case 12:
          bus.$emit("homePage", {
            type: "jump",
            path: "/HandoverLogLook",
            title: this.LifeCareManagement.title_12
          });
          break;
        case 26:
          bus.$emit("homePage", {
            type: "jump",
            path: "/HandoverLogLookMonth",
            title: "月交班日志查看"
          });
          break;
        case 13:
          bus.$emit("homePage", {
            type: "jump",
            path: "/changeFeeList",
            title: this.LifeCareManagement.title_13
          });
          break;
        case 14:
          bus.$emit("homePage", {
            type: "jump",
            path: "/changeFeeRootList",
            title: this.LifeCareManagement.title_14
          });
          break;
        case 15:
          bus.$emit("homePage", {
            type: "jump",
            path: "/OldmanBirthday",
            title: this.LifeCareManagement.title_15
          });
          break;
        case 16:
          bus.$emit("homePage", {
            type: "jump",
            path: "/OldmanLeave",
            title: this.LifeCareManagement.title_16
          });
          break;
        case 17:
          bus.$emit("homePage", {
            type: "jump",
            path: "/WeeklyMenu",
            title: this.LifeCareManagement.title_17
          });
          break;
        case 18:
          bus.$emit("homePage", {
            type: "jump",
            path: "/FoodManagement",
            title: this.LifeCareManagement.title_18
          });
          break;
        case 19:
          bus.$emit("homePage", {
            type: "jump",
            path: "/LeaveHospital",
            title: this.LifeCareManagement.title_19
          });
          break;
        case 21:
          bus.$emit("homePage", {
            type: "jump",
            path: "/ThisMonthArrangePlan",
            title: '本月排班计划'
          });
          break;
        case 22:
          bus.$emit("homePage", {
            type: "jump",
            path: "/SchedulingMonthApproval",
            title: '月排班计划审批'
          });
          break;
        case 23:
          bus.$emit("homePage", {
            type: "jump",
            path: "/NursingLogMonth",
            title: '护工护理日志(月)'
          });
          break;
        case 24:
          bus.$emit("homePage", {
            type: "jump",
            path: "/NursingHandoverLogMonth",
            title: '护工交班日志(月)'
          });
          break;
        default:
          bus.$emit("homePage", {
            type: "jump",
            path: "/LeaveHospitalApproval",
            title: this.LifeCareManagement.title_20
          });
      }
    },
    /**
     * 获取菜单栏的数据列表
     */
    getPageData() {
      this.infoList = [
        {
          img: require("@/assets/beadhouse/jiaobanrizhi2.png"),
          title: this.LifeCareManagement.title_11,
          text: this.LifeCareManagement.text_11,
          uid: 11,
          url: '/NursingHandoverLog'
        }, {
          img: require("@/assets/beadhouse/jiaobanrizhi.png"),
          title: this.LifeCareManagement.title_12,
          text: this.LifeCareManagement.text_12,
          uid: 12,
          url: '/HandoverLogLook'
        }, {
          img: require("@/assets/beadhouse/banzhangrizhi2.png"),
          title: this.LifeCareManagement.title_7,
          text: this.LifeCareManagement.text_7,
          uid: 7,
          url: '/MonitorLog'
        }, {
          img: require("@/assets/beadhouse/banzhangrizhi.png"),
          title: this.LifeCareManagement.title_8,
          text: this.LifeCareManagement.text_8,
          uid: 8,
          url: '/MonitorLogManagement'
        }, {
          img: require("@/assets/beadhouse/hugonghuli.png"),
          title: this.LifeCareManagement.title_9,
          text: this.LifeCareManagement.text_9,
          uid: 9,
          url: '/NursingLog'
        }, {
          img: require("@/assets/beadhouse/hugonghuli2.png"),
          title: this.LifeCareManagement.title_10,
          text: this.LifeCareManagement.text_10,
          uid: 10,
          url: '/NursingLogManagement'
        },{
          img: require("@/assets/beadhouse/hugonghuli2.png"),
          title: this.LifeCareManagement.title_10,
          text: this.LifeCareManagement.text_10,
          uid: 25,
          url: '/NursingLogManagementMonth'
        },  {
          img: require("@/assets/beadhouse/jiaobanrizhi2.png"),
          title: "护工交班日志(月)",
          text: "护工对每天的日常护理进行记录",
          uid: 24,
          url: '/护工每天下班前对每天的异常情况进行记录'
        }
      ];
    }
  },
  created() {
    this.getPageData();
  },
  mounted() { }
};
</script>
<style lang="scss" scoped>
.public_bg {
  min-width: 1360px;
  padding: 0 0 20px 0;
  background: #fefefe;
  border: 1px #f1eff2 solid;

  .nurse_top {
    border: 1px #f1eff2 solid;
    background: #f9f7fa;
    position: relative;

    img {
      margin: 14px 12px;
    }

    h5 {
      display: inline-block;
      position: absolute;
      top: 12px;
      font-size: 18px;
    }
  }

  .row_link {
    width: 1259px;

    margin: 34px 35px;

    .item {
      width: 275px;
      height: 99px;
      border: #f0f0f2 1px solid;
      margin-bottom: 34px;
      margin-right: 34px;
      float: left;
      cursor: pointer;

      img {
        float: left;
        margin: 8px 23px 8px 33px;
        margin-right: 16px;
      }

      span {
        color: #666666;
      }

      h5 {
        margin-top: 21px;
        margin-bottom: 8px;
      }

      a:hover {
        color: #333;
      }
    }

    .item:hover {
      border: 1px solid red;
    }
  }
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}

.clearfix {
  *zoom: 1;
}</style>
